<template>
  <div>
    <div class="flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">Past Consultation</div>
    </div>
    <!--core main-->
    <div v-if="pastConsults.length < 1" class="flex flex-col bg-white px-4 py-6 text-grey-darker text-sm border-solid border-b border-grey-lightest">No consultation found</div>
    <div class="flex flex-col bg-white overflow-y-auto px-4 py-6 flex-no-shrink flex-no-grow" v-if="!showDetails && pastConsults.length > 0" style="height: calc(100vh - 8rem)">
      <div class="flex flex-row ml-auto mr-2 mb-1 items-center flex-no-shrink flex-no-grow">
        <input @click="fetchQueries()" class="flex m-1 mb-2" type="checkbox" :checked="queries"/> 
        <div class="flex ml-1 text-sm font-semibold">Show Conversations</div>
      </div>
      <!--START-Header-->
      <div class="grid_container bg-grey-lightest">
        <div class="item_header text-grey-darker font-semibold text-xs">Doctor</div>
        <div class="item_header text-grey-darker font-semibold text-xs">Date</div>
        <div class="item_header text-grey-darker font-semibold text-xs"></div>
        <div class="item_header text-grey-darker font-semibold text-xs"></div>
        <div class="item_header text-grey-darker font-semibold text-xs"></div>
      </div>
      <!--END-Header-->
      <div class="grid_container text-grey-darkest text-xs" v-for="(consult, index) in pastConsults" :key="index">
        <div class="item truncate" :title="consult.doctor_name">{{consult.doctor_name}}</div>
        <div v-if="consult.consultation_type === 'text'" class="item">{{consult.consultation_date | formatDate}}</div>
        <div v-else class="item">{{consult.consultation_date | formatDate}}</div>
        <div v-if="consult.prescription" class="item"><span class="text-blue font-semibold cursor-pointer" @click="getDocument(consult)">Prescription</span></div>
        <div v-else class="item"><span class="text-grey">Prescription</span></div>
        <div v-if="consult.consultation_type === 'text'" class="item"><span class="cursor-pointer font-semibold" v-bind:class="[consult.is_query ? 'text-purple' : 'text-blue']" @click="fetchMessages(consult)">Chat</span></div>
        <div v-else class="item"><span class="text-grey font-semibold">Call</span></div>
        <div class="item"><span class="cursor-pointer font-semibold" v-bind:class="[consult.is_query ? 'text-purple' : 'text-blue']" @click="showConsultDetails('Summary', consult)">Summary</span></div>
      </div>  
    </div>
    <div v-if="showDetails" class="mx-4 mt-6 shadow">
      <div class="bg-grey-lightest h-8 flex flex-row rounded-sm justify-between">
        <div class="text-grey-darkest text-xs self-center pl-2">Consultation with {{selectedConsult.doctor_name}}</div>
        <div class="self-center text-xs text-blue pr-2 cursor-pointer font-semibold" @click="close">CLOSE</div>
      </div>
      <div class="bg-grey-extralight h-8 flex flex-row rounded-sm shadow">
        <div class="text-grey-darker text-xs self-center pl-2">{{selectedType}}</div>
      </div>
      <div v-if="selectedType === 'Summary'" class="flex flex-col rounded-sm p-2 border-b border-solid border-grey-lightest bg-white" id="Summary">
        <div class="text-sm p-1 py-2 text-grey-darker"><span class="text-grey-dark font-semibold">CHIEF COMPLAINT: </span>{{selectedConsult.chief_compliant ? selectedConsult.chief_compliant : 'NA'}}</div>
        <div class="text-sm p-1 py-2 text-grey-darker"><span class="text-grey-dark font-semibold">DIAGNOSIS: </span>{{selectedConsult.diagnosis ? selectedConsult.diagnosis : 'NA'}}</div>
        <div class="text-sm p-1 py-2 text-grey-darker"><span class="text-grey-dark font-semibold">SUMMARY: </span><span v-html="selectedConsult.summary ? selectedConsult.summary : 'NA'"></span></div>
      </div>
      <div v-if="selectedType === 'Chat'" class="container flex flex-row rounded-sm p-2 border-b border-solid border-grey-lightest overflow-y-auto bg-white" id="Chat">
        <div class="text-grey-darker text-sm" v-if="messages.length<1"> No message exchanged</div>
        <chat-message-container style="height: calc(100vh - 15rem);" :messages="messages" :isActivePastChat="true" v-else/>
      </div>
    </div>
    <!-- pagination -->
    <div v-else class="fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow" v-bind:style="$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);'">
      <paginate
        v-show="totalPages>0"
        :page-count="totalPages"
        :click-handler="changePage"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :active-class="'active-page'"
        :page-class="'list-item'"
        :next-class="'next-class'"
        :prev-class="'prev-class'"
        :container-class="'pagination text-xs flex fixed pin-r pr-5'">
        <span slot="prevContent" class="hover:bg-blue hover:text-white flex flex-col self-center justify-center items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink cursor-pointer text-grey"><i class="fa fa-s fa-arrow-left"></i></span>
        <span slot="nextContent" class="hover:bg-blue hover:text-white flex flex-col self-center justify-center items-center h-6 w-6 rounded-full flex-no-grow flex-no-shrink cursor-pointer text-grey"><i class="fa fa-s fa-arrow-right"></i></span>
      </paginate>
    </div>
  </div>
</template>

<script>
import ChatMessageContainer from '@/components/Chat/ChatMessageContainer'
import {mapGetters} from 'vuex'
import consultation from '../../api/consultation'
import Paginate from 'vuejs-paginate'
import documents from '../../api/customer/document'
export default {
  components: {
    ChatMessageContainer,
    Paginate
  },
  data () {
    return {
      showDetails: false,
      selectedConsult: {},
      selectedType: '',
      pastConsults: [],
      messages: [],
      totalPages: 1,
      queries: false
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile'
    })
  },
  watch: {
    customer: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedConsult = {}
        this.selectedType = ''
        this.showDetails = false
        this.queries = false
        this.getPastConsults()
        return
      }
    }
  },
  mounted () {
    this.getPastConsults()
  },
  methods: {
    showConsultDetails: function (type, consult) {
      this.showDetails = true
      this.selectedConsult = consult
      this.selectedType = type
    },
    fetchMessages: function (consult) {
      consultation.fetchMesaagesConsultation(consult.consultation_id, consult.consultation_request_id).then(response => {
        if (response.status === 200) {
          this.messages = response.body.messages
          this.selectedType = 'Chat'
          this.showDetails = true
        } else {
        }
      }, response => {
      })
    },
    close: function () {
      this.showDetails = false
      this.selectedConsult = {}
    },
    getPastConsults: function (page = 1, queries = false) {
      if (this.customer) {
        consultation.getCustomerPastConsultation(this.customer.customerId, page, queries).then(response => {
          if (response.status === 200) {
            this.pastConsults = response.body.past_consults
            this.totalPages = Math.ceil(response.body.total / response.body.per_page)
          } else {
          }
        }, response => {
        })
      }
    },
    changePage: function (pageNum) {
      this.getPastConsults(pageNum)
    },
    getDocument: function (consult) {
      documents.fetch('Prescription', consult.prescription.id).then(response => {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank')
        } else {
          alert('Error fetching data')
        }
      }, response => {
      })
    },
    fetchQueries: function () {
      this.queries = !this.queries

      if (this.queries) {
        this.getPastConsults(1, true)
      } else {
        this.getPastConsults()
      }
    }
  }
}
</script>

<style scoped>
.grid_container{
  display: grid;
  border-collapse: collapse;
  padding: 10px;
  grid-template-columns: 
    minmax(90px, auto)      /* Doctor Name */
    minmax(125px, 130px)       /* Date Time */
    minmax(70px, 80px)       /* Prescription */
    minmax(50px, 50px)      /* chat */
    minmax(60px, 60px)        /* Summary */

}
.item_header{
    padding: 0px;
    margin: 0px 1px 0px 1px;
    text-align: left;
    /* font-size: 12px;
    color: #9B9B9B; */
}
.item{
    padding: 0px;
    margin: 0px 1px 0px 1px;
    text-align: left;
    /* font-size: 12px; */
    /* color: #4a4a4a; */
}
.container {
  background-image: url('../../assets/chat-background.jpg');
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/CustomerPastConsults.vue